__turbopack_context__.v({
  "closed": "location-hours-card-module-scss-module__RcqufG__closed",
  "currentHours": "location-hours-card-module-scss-module__RcqufG__currentHours",
  "scheduleDetails": "location-hours-card-module-scss-module__RcqufG__scheduleDetails",
});
